var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 36,
    viewBox: "0 0 42 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "156.838%",
    x2: "50%",
    y2: "221.117%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.03,
    offset: "99.961%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "156.838%",
    x2: "50%",
    y2: "221.117%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.03,
    offset: "99.961%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "156.838%",
    x2: "50%",
    y2: "221.117%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.03,
    offset: "99.961%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22.704 14.172 8.223 13.38a2 2 0 0 1-1.704 3.048H12.777a2 2 0 0 1-1.704-3.047l8.223-13.38a2 2 0 0 1 3.408 0z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#F2C820",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m23.083 7.24 13.26 23.168A2.4 2.4 0 0 1 34.262 34H7.739a2.4 2.4 0 0 1-2.083-3.592L18.917 7.239a2.4 2.4 0 0 1 4.166 0z",
    stroke: "#F2C820",
    strokeWidth: 0.5,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.076 3.539 16.816 28.667a2.4 2.4 0 0 1-2.06 3.614l-33.63.16a2.4 2.4 0 0 1-2.085-3.61L18.933 3.545a2.4 2.4 0 0 1 4.143-.005z",
    strokeOpacity: 0.4,
    stroke: "#F2C820",
    strokeWidth: 0.5,
    fill: "url(#d)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUi);
export default __webpack_public_path__ + "static/media/icon-ui.2579fcbab8ded2a5978ad2b4eecea69c.svg";
export { ForwardRef as ReactComponent };